module.exports = __webpack_public_path__ + "static/media/linkedin-logo.8220d480.svg";